import { useState, type FormEvent } from 'react';
import { Logo } from '../componentes/Marca';
import { useSessao } from '../auth/sessao';

// O comando de instalação sai de `location.origin` e não de uma constante: o
// painel é servido pela mesma origem da API em produção, e em desenvolvimento
// pelo Vite com proxy. Uma URL fixa aqui mandaria o dev instalar o CLI
// apontando para a máquina de outra pessoa.
const comandoDeInstalacao = () => `irm ${window.location.origin}/cli/install.ps1 | iex`;

export function Login() {
  const { logar } = useSessao();
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [erro, setErro] = useState('');
  const [enviando, setEnviando] = useState(false);

  async function submeter(e: FormEvent) {
    e.preventDefault();
    setErro('');
    setEnviando(true);
    try {
      await logar(email.trim(), senha);
    } catch (falha) {
      // 401 com corpo `{error}` é credencial errada e a mensagem vem do
      // servidor; exceção sem status é rede, e aí o recado tem de ser outro,
      // senão o dev fica tentando a senha contra um servidor que está fora
      const msg = falha instanceof Error ? falha.message : '';
      setErro(msg && !/^HTTP 5|fetch|network|Failed/i.test(msg) ? msg : 'servidor indisponível');
    } finally {
      setEnviando(false);
      setSenha('');
    }
  }

  return (
    <div id="login">
      <form className="login-card" onSubmit={submeter}>
        <div className="logo"><Logo /></div>
        <h1>Context Engine</h1>
        <p>Entre para acessar a documentação dos seus projetos.</p>
        <div className="login-err" role="alert" aria-live="assertive">{erro}</div>
        <div className="field">
          <label htmlFor="li-email">Email</label>
          <input
            id="li-email" type="email" autoComplete="username" placeholder="voce@extreme.digital"
            value={email} onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        <div className="field">
          <label htmlFor="li-pass">Senha</label>
          <input
            id="li-pass" type="password" autoComplete="current-password" placeholder="••••••••"
            value={senha} onChange={(e) => setSenha(e.target.value)}
          />
        </div>
        <button className="btn" type="submit" style={{ width: '100%' }} disabled={enviando}>
          {enviando ? 'Entrando…' : 'Entrar'}
        </button>
        <p className="cli-hint">
          CLI no Windows (Node 20+). Depois: <b>eng login</b> e, no clone do projeto, <b>eng use &lt;slug&gt;</b>.
          <code>{comandoDeInstalacao()}</code>
        </p>
      </form>
    </div>
  );
}
